//
//
//
//
//
//
//

export default {
  data () {
    return {
      msg: '',
      showFlag: false,
    }
  },
  created () {
  },
  methods: {
    async show (obj = undefined, msg) {
      this.showFlag = true
      this.msg = msg
    },
    hide () {
      this.showFlag = false
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/basic/VyFixLoading.vue